const React = require('react');
const { createElement: h, useEffect, useRef } = React;

// Same OAuth client as the API's connected-accounts flow — GSI only needs the
// (public) client id; the ID token is verified server-side at /auth/google.
var GOOGLE_CLIENT_ID = process.env.REACT_APP_GOOGLE_CLIENT_ID
  || '1023398940776-fs644rvkv3uoamc4if9cf0047slg1tfe.apps.googleusercontent.com';

var GSI_SRC = 'https://accounts.google.com/gsi/client';
var gsiLoadPromise = null;

// Load the Google Identity Services script once per page, shared between
// mounts (mode switches remount the button but must not re-add the script).
function loadGsi() {
  if (window.google && window.google.accounts && window.google.accounts.id) {
    return Promise.resolve();
  }
  if (!gsiLoadPromise) {
    gsiLoadPromise = new Promise(function(resolve, reject) {
      var script = document.createElement('script');
      script.src = GSI_SRC;
      script.async = true;
      script.onload = function() { resolve(); };
      script.onerror = function() { gsiLoadPromise = null; reject(new Error('Could not load Google sign-in.')); };
      document.head.appendChild(script);
    });
  }
  return gsiLoadPromise;
}

// Renders Google's official "Sign in with Google" button.
// props.onCredential(idToken) is called with the signed ID token.
// props.text: 'signin_with' | 'signup_with' (Google localizes the label).
function GoogleSigninButton(props) {
  var containerRef = useRef(null);
  var onCredentialRef = useRef(props.onCredential);
  onCredentialRef.current = props.onCredential;
  var text = props.text || 'signin_with';

  useEffect(function() {
    var cancelled = false;
    loadGsi().then(function() {
      if (cancelled || !containerRef.current) return;
      window.google.accounts.id.initialize({
        client_id: GOOGLE_CLIENT_ID,
        callback: function(response) {
          if (response && response.credential && onCredentialRef.current) {
            onCredentialRef.current(response.credential);
          }
        }
      });
      window.google.accounts.id.renderButton(containerRef.current, {
        type: 'standard',
        theme: 'outline',
        size: 'large',
        shape: 'pill',
        width: 320,
        text: text
      });
    }).catch(function() {
      // Script blocked/offline — the button simply doesn't render; the
      // password form is unaffected.
    });
    return function() { cancelled = true; };
  }, [text]);

  return h('div', { className: 'lp-google', ref: containerRef });
}

module.exports = GoogleSigninButton;
